import React, { useEffect, useState } from 'react';
import { urlWebsite } from '../../config';
import api from '../../services/api';
import {Container, Sponsor, Apoio, SponsorGrid, ApoioGrid } from './styles';




const apoios = [
{ image : '/assets/evento/apoio/1.jpg', url: ''},
{ image : '/assets/evento/apoio/2.jpg', url: ''},
{ image : '/assets/evento/apoio/3.jpg', url: ''},
{ image : '/assets/evento/apoio/4.jpg', url: ''},
{ image : '/assets/evento/apoio/5.jpg', url: ''},
{ image : '/assets/evento/apoio/6.jpg', url: ''},
{ image : '/assets/evento/apoio/7.jpg', url: ''},
{ image : '/assets/evento/apoio/8.jpg', url: ''},
{ image : '/assets/evento/apoio/9.jpg', url: ''},
{ image : '/assets/evento/apoio/10.jpg', url: ''},
{ image : '/assets/evento/apoio/11.jpg', url: ''},
{ image : '/assets/evento/apoio/12.jpg', url: ''},
{ image : '/assets/evento/apoio/13.jpg', url: ''},


];

export const sponsors = [
  { image : '/assets/evento/patrocinadores/1.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/2.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/3.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/4.jpg', url: ''},
{ image : '/assets/evento/patrocinadores/5.jpg', url: ''},
{ image : '/assets/evento/apoio/14.jpg', url: ''}
]

interface ISponsor {
  url : string;
  link_url ?: string;
  
}

interface ISponsors {
  title : string;
  position: number;
  sponsors : Array<ISponsor>;
  size ?: string;
}

const FooterLayout: React.FC = ({ children }) => {

  const [sponsors,setSponsors] = useState<Array<ISponsors>>([])

  useEffect(() => {
    
    const load = async() => {
    const response = await api.get('sponsors-list');
    if(response) {

      let data = response.data;
      data = data?.sort( (a,b) => a.position - b.position );

      setSponsors(data || []);
    }
    return;
    }

load();

  },[])

  return (
<>
{ sponsors && sponsors.length > 0 && <Container id="patrocinadores" style={{margin: '20px 0px' }}>


  { sponsors && sponsors.map( lists => (


<div style={{ display: 'flex', flexDirection:'column', alignItems: 'center', justifyContent: 'flex-start', minWidth: '250px', maxWidth: '1000px', margin: '10px 20px'}}>
<h2 style={{color: '#fff', marginTop: '10px', marginBottom: '10px'}}>{lists.title}</h2>
  <ApoioGrid size={lists.size}>
  {lists.sponsors && lists.sponsors.map( apoio => ( apoio.link_url ? <a href={apoio.link_url} target="_BLANK" style={{background: '#fff',   margin: '5px',   borderRadius: '20px', boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}}><Apoio background={`${urlWebsite}/${apoio.url}`} key={apoio.url} /></a> : <div style={{background: '#fff', margin: '5px',     borderRadius: '20px', boxShadow: '2px 2px 5px rgb(0 0 0 / 50%)'}} ><Apoio background={`${urlWebsite}/${apoio.url}`} key={apoio.url} /></div>) )}

  </ApoioGrid>
  </div>

  ))


  }
    
        </Container>}

        </>
  );
};

export default FooterLayout;
